// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news-list-bookmark {\n  position: absolute;\n  right: 8px;\n  bottom: -4px;\n}\n\n.news-banner-wrapper .lazy-load-image-loaded {\n  width: 100%;\n  filter: blur(0);\n  transition: filter 0.3s;\n}\n", ""]);
// Exports
module.exports = exports;
